import React, { useState } from "react";
import AdminHeader from "../AdminHeader/AdminHeader";
import SideBarAdmin from "../SideBarAdmin/SideBarAdmin";
// import AddVehicleDrawer from "./AddVehicleDrawer";
// import TableDateAdminVehicle from "./TableDateAdminVehicle";
// import "./VehiclesAdmin.css";
import { useDispatch } from "react-redux";


import { addVehicle } from "../../redux/AdminReducer";
import AddDrivers from "../AddDrivers/AddDrivers";
import TableDataDrivers from "../TableDataDrivers/TableDataDrivers";
import TableDateCustomers from "../TableDataCustomers/TableDataCustomers";

const AdminDrivers = () => {
  const [rightHeader, setRightHeader] = useState(false);

  const dispatch=useDispatch();

  return (
    <>
      <AdminHeader rightHeader={rightHeader} />

      <div className="topSideVehicles">
        <SideBarAdmin
          setRightHeader={setRightHeader}
          rightHeader={rightHeader}
        />
        <div className="vehicleAdminMain">
          <div className="topTextEditAdmVehic">
            You can see and edit detail about customers here..
          </div>

          <div className="topTextsVehiclAdmin">
            <div className="topInputBtnSearch">
              <input placeholder="Search Vehicle" className="inputSearchVehic" />
              <button className="btnSearchVehicle">Search</button>
            </div>
{/* 
            <div  className="topAddVehicleDrawer">
            
              <AddDrivers/>
            
            
            </div> */}
          </div>
         <div className="topTableAdminVehicles">

         {/* <TableDataDrivers/> */}
         <TableDateCustomers/>
         </div>
        </div>
      </div>
      {/* <div style={{marginTop:"100px"}}>
        hfgjhdfg
      </div> */}
    </>
  );
};

export default AdminDrivers;
